import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const projectsApi = createApi({
  reducerPath: "projectsApi",
  baseQuery: customFetchBase({ url: "projects" }),
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: ({ page = 1, search, code, filters = {} , count = 10 , category} = {}) => {
        const arrFilter = Object?.entries(filters);
        let url = `?no_of_docs_each_page=${count}&page=${page}`;
        // search
        if (search) url += `&search=${search}`;
        // get by code
        if (code) url += `&code=${code}`;
        // category
        if (category) url += `&filter_data=category@${category}`;
        // filters
        for (const [key, value] of arrFilter) {
          if (value) {
            url += `&${key}=${value}`;
          }
        }
        return {
          url,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useGetProjectsQuery } = projectsApi;
